import React from 'react';
import TextTool from 'components/tools/TextTool';
import FiltersTool from 'components/tools/FiltersTool';
import AdjustTool from 'components/tools/AdjustTool';
import TransformTool from 'components/tools/TransformTool';
import StickersTool from 'components/tools/StickersTool';
import CropTool from 'components/tools/CropTool';
import CanvasRotateTool from 'components/tools/CanvasRotateTool';

export default function ToolOptions({ activeTool, cropToolRef }) {
  return (
    <div className="flex items-center bg-lt-beige mt-2 h-[114px] md:h-[90px] overflow-x-auto w-full px-4 snap-x snap-always md:snap-none scroll-smooth">
      <TransformTool isActive={activeTool === 'transform'} />
      <TextTool isActive={activeTool === 'text'} />
      <FiltersTool isActive={activeTool === 'filters'} />
      <AdjustTool isActive={activeTool === 'adjust'} />
      <StickersTool isActive={activeTool === 'stickers'} />
      <CanvasRotateTool isActive={activeTool === 'rotate'} />
      <CropTool ref={cropToolRef} isActive={activeTool === 'crop'} />
    </div>
  );
}
